"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
exports.__esModule = true;
exports.default = void 0;
var _styledComponents = require("styled-components");
var _layout = require("../../utils/layout");
var _getWidth = _interopRequireDefault(require("./getWidth"));
var _getDisplay = _interopRequireDefault(require("./getDisplay"));
var _getBasis = _interopRequireDefault(require("./getBasis"));
var _getSpacingToken = _interopRequireDefault(require("../../common/getSpacingToken"));
const getViewportFlexStyles = viewport => props => {
  const {
    flex,
    theme
  } = props;
  const {
    inline,
    direction,
    wrap,
    grow,
    shrink,
    basis,
    justify,
    align,
    spaceAfter
  } = props[viewport];
  const flexStyles = flex && (0, _styledComponents.css)(["display:", ";flex-direction:", ";flex-wrap:", ";flex-grow:", ";flex-shrink:", ";flex-basis:", ";justify-content:", ";align-content:", ";align-items:", ";"], (0, _getDisplay.default)(inline), (0, _layout.getDirection)(direction), (0, _layout.getWrap)(wrap), (0, _layout.getGrow)(grow), (0, _layout.getShrink)(shrink), (0, _getBasis.default)(basis)({
    theme
  }), (0, _layout.getJustify)(justify), (0, _layout.getAlign)(align), (0, _layout.getAlign)(align));
  return (0, _styledComponents.css)(["", ";width:", ";margin-bottom:", ";"], flexStyles, (0, _getWidth.default)(inline), (0, _getSpacingToken.default)({
    spaceAfter,
    theme
  }));
};
var _default = getViewportFlexStyles;
exports.default = _default;